<template>
    <div class="orderStyle" :style="{ minHeight: pageHeight + 'px' }">
        <div class="orderBanner">
            <van-nav-bar title="支付订单" left-text="" left-arrow @click-left="onClickLeft" />
            <div class="tap-style">
                <div class="tap-icons"><van-icon name="checked" color="#8fc323" size="36px" class="tap-icon" /></div>
                <div class="tap-title">亲，订单已成功生成，请尽快完成支付！</div>
            </div>
        </div>
        <div class="orderCtn">
            <div class="item-content">
                <div class="item-ctn-title">订单信息</div>
                <div class="item">
                    <div class="label">订单号</div>
                    <div class="text"> {{ detail.tradeNo }} </div>
                </div>
                <div class="item">
                    <div class="label">产品名称</div>
                    <div class="text"> {{ detail.productionName }} </div>
                </div>
                <div class="item">
                    <div class="label">价格</div>
                    <div class="text">¥{{ Number(detail.price).toFixed(2) }}</div>
                </div>
                <div class="item">
                    <div class="label">被保人数</div>
                    <div class="text">{{ detail.num }}</div>
                </div>
                <div class="item">
                    <div class="label">起保日期</div>
                    <div class="text">{{ detail.startDate }}</div>
                </div>
                <div class="item">
                    <div class="label">终止日期</div>
                    <div class="text">{{ detail.endDate }}</div>
                </div>
            </div>
            <div class="bar10px"></div>
            <div class="item-content">
                <div class="item-ctn-title">支付方式</div>
                <div class="choose-item">
                    <van-radio-group v-model="payType">
                        <van-cell-group inset>
                            <img src="./assets/imgs/alpay.png" style="width: 24px;height: 24px;margin-top: 10px;" alt="">
                            <van-cell title="支付宝支付" clickable @click="payType = 'A01'">
                                <template #right-icon>
                                    <van-radio name="A01" />
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                </div>
            </div>
        </div>
        <div class="foot-btn">
            <div class="left">
                <span style="font-weight: 800;font-size: 14px;">单价 <span style="color: #fe9404;font-size: 16px;">¥{{ Number(detail.price).toFixed(2) }}</span> </span>
            </div>
            <div class="right" @click="goPay()">立即支付</div>
        </div>
    </div>
</template>
  
  <script>
  import storejs from "store";
  import moment from 'moment';
  import { Collapse, CollapseItem,Icon,Toast,Dialog,NavBar,Cell,CellGroup,Radio,RadioGroup  } from 'vant';
  
  export default {
    name: "OtherOrder",
    components: {
      [Collapse.name]: Collapse,
      [CollapseItem.name]:CollapseItem,
      [Icon.name]:Icon,
      [Toast.name]:Toast,
      [Dialog.name]:Dialog,
      [NavBar.name]:NavBar,
      [Cell.name]:Cell,
      [CellGroup.name]:CellGroup,
      [Radio.name]:Radio,
      [RadioGroup.name]:RadioGroup
    },
    data(){
      return{
        moment:moment,
        pageHeight: window.innerHeight,
        publicData: storejs.get("publicData"),
        detail:{},
        tradeNo:this.$route.query.tradeNo,
        payType:'A01',
        payinfo:'',
        paySuccess:false,
        payInterval: "",
      }
    },
    watch: {
    },
    mounted() {
      this.init()
    },
    methods: {
      async init(){
        await this.getorderList()
      },

      onClickLeft(){
            window.location.href = this.$route.query.back
      },

      async getorderList(){
        let res = await this.$http.post('api/open/getTradeNoByBill',{
            tradeNo:this.$route.query.tradeNo,
        })
        if(res.code == 0){
            this.detail = res.t
            document.title =  "希望保" + "—" + this.detail.productionName;
        }else{
            this.$toast(res.msg);
        }
      },
      async goPay(){
        let res = await this.$http.post('api/order.union.create',{
            accountBillId: this.detail.accountBillId,
            paytype: "A01",
            acct: this.detail.accountId
        })
        if(res.code == 0){
            if(res.t.payinfo){
                this.payinfo = res.t.payinfo
                window.location.href = this.payinfo
                this.refershPayResult()
            }else{
                this.$toast(res.t.errmsg);
            }
        }else{
            this.$toast(res.msg);
        }

      },
      
      async refershPayResult() {
        let num = 0;
        this.payInterval = setInterval(async () => {
            if (num == 60) {
                clearInterval(this.payInterval);
            }
            num++;
            let check = await this.$http.post("api/order.check", { bid:this.detail.accountBillId });
            if (check.code == 0) {
                clearInterval(this.payInterval);
                this.paySuccess = true;
                window.location.href = this.$route.query.callback
            } else {
                this.paySuccess = false;
            }
        }, 1000);
        },
    },
  }
  </script>
  
  <style lang="scss" scoped>

    .orderStyle{
        width: 100%;
        height: 100%;
        background: whitesmoke;
        .orderBanner{
            height: 170px;
            width: 100%;
            background: whitesmoke;
            .tap-style{
                height: 100px;
                position: relative;
                .tap-icons {
                    height: 50px;
                    text-align: center;
                    .tap-icon{
                        position: absolute;
                        left: 45%;
                        top: 15%;
                    }
                }
                .tap-title {
                    height: 50px;
                    line-height: 50px;
                    text-align: center;
                    color:#31a4d3;
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }
        .orderCtn{
            height: 100%;
            width: 100%;
            padding: 10px 8px;
            box-sizing: border-box;
            background: whitesmoke;
            .item-content {
                background: #fff;
                padding: 15px;
                box-sizing: border-box;
                .item-ctn-title {
                    height: 20px;
                    line-height: 20px;
                    font-size: 16px;
                    color: #31a4d3;
                    font-weight: 500;
                    border-left: 3px solid #31a4d3;
                    padding-left: 5px;
                    margin-bottom: 15px;
                    box-sizing: border-box;

                }
                .item {
                    display: flex;
                    // height: 40px;
                    line-height: 38px;
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    border-bottom: 1px solid #eee;
                    // color: rgba(102, 102, 102, 1);
                    color: #333333;
                    .label {
                        width: 0.8rem;
                        flex-shrink: 0;
                    }
                    .text {
                        flex: 1;
                        color: #333333;
                        font-size: 16px;
                    }
                }
            }
        }
        .foot-btn {
            height: 60px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px -1px 8px 3px rgba(0, 0, 0, 0.04);
            position: fixed;
            bottom: 0;
            width: 100%;
            display: flex;
            z-index: 1000;
            left: 0;
            .left {
                width: 150px;
                flex-shrink: 0;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                //   color: rgba(0, 211, 133, 1);
                color: #666;
                background: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
                position: relative;
                &:after {
                    content: " ";
                    position: absolute;
                    top: 0;
                    width: 1px;
                    bottom: 0;
                    color: #c7c7c7;
                    right: 0;
                    // border-right: 1px solid #c7c7c7;
                    transform: scaleX(0.5);
                    height: 60%;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            .right {
                flex: 1;
                // background: rgba(0, 211, 133, 1);
                background: #fe9404;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 700;
                color: rgba(255, 255, 255, 1);
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
    .bar10px {
        height: 10px;
        background: rgba(244, 244, 244, 1);
        width: 100%;
    }
  </style>
  
  <style lang="scss">

    .orderStyle {
        .orderBanner {
            .van-nav-bar {
                height: 55px !important;
                background-color: #099fdf;
            }
            .van-nav-bar__title {
                color: #e3eef0;
                font-size: 18px;
            }
            .van-nav-bar__arrow {
                font-size: 30px !important;
                color: #e3eef0;
            }
        }
        .choose-item {
            .van-cell {
                padding-left: 10px;
            }
            .van-cell-group {
                display: flex;
            }
            .van-radio__icon--checked .van-icon {
                background-color: #8fc323;
                border-color: #8fc323;
            }
        }
    }
  </style>